import { createToggleDriver } from '../../primitives/toggle/toggle.driver';
import { compKey } from './key';
export var createToggleListDriver = function (wrapper) {
    var base = wrapper.$("." + compKey);
    var getToggleByIdx = function (idx) { return createToggleDriver(base.$$('.toggle-list-item').get(idx)); };
    return {
        getToggleTexts: function () { return base.$$('.toggle-text').text(); },
        getToggleHasInfoTooltip: function (idx) { return base.$$('.toggle-info-tooltip').get(idx).exists(); },
        getToggleIsOn: function (idx) { return getToggleByIdx(idx).isOn(); },
        getToggleHasTooltip: function (idx) { return getToggleByIdx(idx).hasTooltip(); },
        getToggleIsDisabled: function (idx) { return getToggleByIdx(idx).isDisabled(); },
        toggle: function (idx) { return getToggleByIdx(idx).toggle(); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map